//wss://granu-api.d3cisive.com/ws
import { TireReading } from "../types/TireReadingType";
import { OverwriteType } from "../types/OverwriteType";

const API_KEY = process.env.NEXT_PUBLIC_API_KEY;

export const createMachineTestRead = async () => {
    if (!process.env.NEXT_PUBLIC_API_URL) {
        // throw new Error('API_URL is not defined in the environment variables');
        process.env.NEXT_PUBLIC_API_URL = 'https://granu-api.d3cisive.com';
    }


    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/v1/dev/aku`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    const data: TireReading = await response.json();
    return data;
}

export const createOverwriteRead = async (overwrite: OverwriteType) => {
    if (!process.env.NEXT_PUBLIC_API_URL) {
        throw new Error('API_URL is not defined in the environment variables');
    }
    if (!API_KEY) {
        throw new Error('API_KEY is not defined in the environment variables');
    }

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/v1/overwrites`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'API_KEY': API_KEY,
        },
        body: JSON.stringify(overwrite),
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    const data: TireReading = await response.json();
    console.log("Overwrite created:", data);
}


export const approveReadingInstant = async (readingId: number) => {
    if (!process.env.NEXT_PUBLIC_API_URL) {
        throw new Error('API_URL is not defined in the environment variables');
    }
    if (!API_KEY) {
        throw new Error('API_KEY is not defined in the environment variables');
    }

    const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/v1/overwrites/confirm`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'API_KEY': API_KEY,
        },
        body: JSON.stringify({ machine_read_id: readingId }),
    });

    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    const data: TireReading = await response.json();
    console.log("Reading approved:", data);
}
